import { apiZodios } from '~api/apiZodios'
import { API_URL } from '~config'
import { QueryAnalysis, ResponseDisplayLink } from '~types'

interface StreamResponse {
  step:
    | 'check_conversation_history'
    | 'query_analysis'
    | 'retrieval'
    | 'generation'
    | 'partial_response'
    | 'complete_response'
    | 'error'
  user_id?: string
  chat_id: string
  query_analysis?: QueryAnalysis
  response_id?: string
  response_text: string
  sources?: ResponseDisplayLink[]
}

export const streamAIResponse = async (
  generateResponseStreamRequest: Parameters<typeof apiZodios.ai_generateResponseStream>[0],
  onMessageCallback: (response: StreamResponse, isFirstResponse: boolean) => void,
  errorCallback: (errorMessage: string) => void,
): Promise<void> => {
  try {
    // Initialize response stream
    const initResponse = await fetch(`${API_URL}/ai/generate-response-stream/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(generateResponseStreamRequest),
    })

    if (!initResponse.ok) {
      errorCallback('Error generating response. Please try entering your message again.')
      return
    }

    const { response_stream_id: responseStreamId } = (await initResponse.json()) as {
      response_stream_id: string
    }

    // Open connection to response stream
    const eventSource = new EventSource(`${API_URL}/ai/read-response-stream/${responseStreamId}/`)
    let isFirstMessage = true
    eventSource.onmessage = (event): void => {
      try {
        const response = JSON.parse(event.data) as StreamResponse
        if (response.step === 'error') {
          errorCallback('Error reading response. Please try entering your message again.')
          eventSource.close()
          return
        }

        onMessageCallback(response, isFirstMessage)
        isFirstMessage = false
        if (response.step === 'complete_response') {
          eventSource.close()
        }
      } catch {
        errorCallback('Error parsing response. Please try entering your message again.')
        eventSource.close()
      }
    }
  } catch {
    errorCallback('Unexpected error. Please try entering your message again.')
  }
}
